export const html: string = `<div data-myon-attr-class="bookBrowser -n{{ booksPerRow }} {{ viewAsList? | '-list' }} {{ !viewAsList? | '-card' }}">
	<ul class="bookBrowser_books">
		<li data-myon-template="books" class="bookBrowser_book">{{ element @noescape }}</li>
	</ul>
	<div class="bookBrowser_loading" data-myon-name="loading">
		{{ lang.MESSAGE_LOADING }}
	</div>
</div>`;
